import classNames from 'classnames';
import { type ReactNode, useId } from 'react';
import Heading from '@alltrails/denali/components/Heading';
import type { SubscriptionFeatures } from '@alltrails/types/SubscriptionFeatures';
import UpsellFeature, { type UpsellFeatureVariant } from './UpsellFeature';
import styles from './UpsellFeatureList.module.scss';

export type { UpsellFeatureVariant };

type Props = {
  features: SubscriptionFeatures;
  label?: ReactNode;
  // 'compact' matches the plans-page board (72px thumbnails, smaller label/body). 'default' keeps the generic upsell modal sizing.
  variant?: UpsellFeatureVariant;
};

// Shared feature list used by the generic upsell modals and the plans page (via Plus/PeakMembershipIncludes).
export default function UpsellFeatureList({ features, label, variant = 'default' }: Props) {
  const headingId = useId();
  const isCompact = variant === 'compact';

  return (
    <section aria-labelledby={label ? headingId : undefined} className={classNames(styles.container, { [styles.containerCompact]: isCompact })}>
      {label &&
        (isCompact ? (
          <Heading as="h2" className={styles.sectionLabel} id={headingId} size="100">
            {label}
          </Heading>
        ) : (
          <Heading as="h3" className={styles.sectionLabel} color="tertiary" id={headingId} size="100">
            {label}
          </Heading>
        ))}
      <ul className={styles.list}>
        {features.map((feature, index) => (
          <UpsellFeature feature={feature} key={index} variant={variant} />
        ))}
      </ul>
    </section>
  );
}
